import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import Button, { TYPES } from 'components/Button';
import Image from 'components/ImageV2';
import I18n from 'utils/I18n';
import Settings from 'utils/Settings';

const ReturnsInsuranceUpsell = ({
  addReturnsInsurance,
  analyticsData,
  allItemsAreFinalSale,
  removeReturnsInsurance,
  returnsInsuranceCampaignVariant,
  isBeingUpdated,
  isBeingRemoved,
  isReturnsInsuranceCampaignLoading,
  itemIds,
  productImageUrl,
  handleReturnsInsuranceExposure,
}) => {
  const returnsInsuranceConfig = Settings.returnsInsuranceConfig;
  const assignedVariant = returnsInsuranceConfig?.variants?.[returnsInsuranceCampaignVariant];

  const shouldShowComponent = !(
    (isBeingUpdated && itemIds.length === 0) ||
    !returnsInsuranceCampaignVariant ||
    !assignedVariant ||
    isReturnsInsuranceCampaignLoading ||
    allItemsAreFinalSale
  );

  useEffect(() => {
    handleReturnsInsuranceExposure(shouldShowComponent, analyticsData);
  }, [shouldShowComponent, handleReturnsInsuranceExposure, analyticsData]);

  if (!shouldShowComponent) {
    return null;
  }

  return (
    <div className="CartOverviewDrawerPanel__insurance-upsell px-6 ">
      <div className="flex items-center gap-2 py-4">
        {productImageUrl && (
          <div className="mb-auto h-[40px] w-[40px] shrink-0 rounded-full">
            <Image src={productImageUrl} alt="Returns Insurance Product" width={40} height={40} />
          </div>
        )}
        <div className="flex flex-col gap-1">
          <p className="text-sm font-medium leading-none">
            {I18n.localize('cart.returnsInsurance.title')}
          </p>
          <div className="text-black-50 text-xs">
            {I18n.localize('cart.returnsInsurance.description')}
          </div>

          <div className="flex items-center justify-between">
            <span className="text-sm font-medium">{assignedVariant.value}</span>

            {itemIds.includes(assignedVariant.variantId) ? (
              <Button
                type={TYPES.DEFAULT}
                className="!m-0 !text-xs"
                isSmall
                isDisabled={isBeingUpdated || isBeingRemoved}
                onClick={() => removeReturnsInsurance(assignedVariant.variantId)}
              >
                {I18n.localize('cart.returnsInsurance.remove')}
              </Button>
            ) : (
              <Button
                type={TYPES.DEFAULT}
                className="!m-0 !text-xs"
                isSmall
                isDisabled={isBeingUpdated || isBeingRemoved}
                onClick={() => addReturnsInsurance(assignedVariant.variantId)}
              >
                {I18n.localize('cart.returnsInsurance.add')}
              </Button>
            )}
          </div>
        </div>
      </div>

      <hr className="m-0 h-[1px] border-none bg-gray-200"></hr>
    </div>
  );
};

ReturnsInsuranceUpsell.propTypes = {
  addReturnsInsurance: PropTypes.func.isRequired,
  allItemsAreFinalSale: PropTypes.bool.isRequired,
  removeReturnsInsurance: PropTypes.func.isRequired,
  returnsInsuranceCampaignVariant: PropTypes.string,
  isBeingUpdated: PropTypes.bool.isRequired,
  isBeingRemoved: PropTypes.bool.isRequired,
  isReturnsInsuranceCampaignLoading: PropTypes.bool.isRequired,
  itemIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  productImageUrl: PropTypes.string,
  handleReturnsInsuranceExposure: PropTypes.func.isRequired,
  analyticsData: PropTypes.object,
};

ReturnsInsuranceUpsell.defaultProps = {
  returnsInsuranceCampaignVariant: null,
  productImageUrl: null,
};

export default ReturnsInsuranceUpsell;
